import TableFalseValueComponent from './TableFalseValueComponent';

export default TableFalseValueComponent;
